<template>
  <div class="ailink">
    <webview :src="url" />
  </div>
</template>

<script>
const { ipcRenderer } = window.require("electron");
export default {
  name: "index",
  data() {
    return {
      url: ''
    }
  },
  mounted() {
    const that = this
    ipcRenderer.send('modal-accomplish')
    ipcRenderer.on('receive-modal-data',function(e,arg){
      that.url = arg.data
    })
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.ailink {
  height: 100%;
  width: 100% !important;
  padding: 0 !important;
  overflow: hidden;
  background-color: black;
  webview{
    height: 100%;
    width: 100%;
    border: none;
  }
  iframe{
    height: 100%;
    width: 100%;
    border: none;
  }
}
</style>
